import React, { useState, useEffect } from 'react';
import "./company.css";
import Sidebar from '../../../Components/Sidebar/Sidebar';
import company2 from "../../../Assets/company-2.png";
import company3 from "../../../Assets/company-3.png";
import company4 from "../../../Assets/company-4.png";
import company5 from "../../../Assets/sound-barrier-manufacturer.webp";
import company6 from "../../../Assets/sound-barrier-india.webp";
import { Link } from 'react-router';
import HNavbar from "../../../Components/Navbar/HNavbar";
import MFooter from '../../../Components/Main-Footer/MFooter';

function Company() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const animatedElements = document.querySelectorAll('.com-header,.com-header1,.com-header2,.com-header3,.com-header4, .com-header5');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);

    return (
        <>
            <HNavbar />
            <Sidebar />
            <section id='company' className='company-home-sec'>
                <div className='container p-0'>
                    <div className='col-sm-12 p-3 company-home d-flex flex-column justify-content-center'>
                        <h1 className='com-header'>About Our Company</h1>
                        <h2 className='com-header1'>Leading Soundbarrier Manufacturing Company</h2>
                        <p className='white-para'>Sound Barrier Manufacture is a professional acoustic panel
                            manufacturer and soundproofing solutions<br /> provider specializing
                            in advanced noise control systems for commercial, industrial,
                            and residential spaces.<br /> We design, manufacture, and install
                            high-performance acoustic products that enhance sound clarity<br />
                            and reduce unwanted noise.</p>
                        <p className='white-para'>With strong technical expertise and industry experience,
                            Sound Barrier Manufacture delivers customized<br /> acoustic
                            solutions tailored to modern architectural requirements</p>
                        <Link to="/contact"><button className='btn' type="button">Contact us</button></Link>
                    </div>
                </div>
            </section >
            <section id='company'>
                <div className='container'>
                    <div className='col-sm-12 p-2'>
                        <h1 className='com-header2'>Who We Are</h1>
                        <p>Sound Barrier Manufacture is a trusted name in architectural acoustics and soundproofing solutions. We are

                            a team of acoustic consultants, engineers, designers, and skilled installers committed to delivering measurable

                            acoustic performance.
                        </p>
                        <p>From concept to completion, we ensure every project meets acoustic standards and client expectations.</p>
                    </div>

                    <div className='row g-3 mt-2'>
                        <div className='col-sm-4'>
                            <img src={company2} alt="company" className='img-fluid card-img' />
                        </div>
                        <div className='col-sm-4'>
                            <div className='company-card p-3'>
                                <h2 className='card-title'>Our Mission</h2>
                                <img src={company3} alt="company" className="img-fluid mt-4" />
                                <p className='card-content'>
                                    To provide innovative,<br />
                                    cost-effective, and sustainable<br />
                                    acoustic and soundproofing<br />
                                    solutions that create quieter<br />
                                    and more productive environments
                                </p>
                            </div>
                        </div>

                        <div className='col-sm-4'>
                            <div className='company-card p-3'>
                                <h2 className='card-title'>Our Vision</h2>
                                <img src={company4} alt="company" className="img-fluid mt-4" />
                                <p className='card-content'>
                                    To provide innovative,<br />
                                    cost-effective, and sustainable<br />
                                    acoustic and soundproofing<br />
                                    solutions that create quieter<br />
                                    and more productive environments
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className='service p-2'>
                        <h1 className='com-header3'>Our Core Services</h1>
                        <div className='row'>
                            <div className='col-sm-12 col-md-6 justify-content-center d-flex align-items-center'>
                                <img className='img-fluid' src={company5} alt="img" />
                            </div>
                            <div className='col-sm-12 col-md-6 align-items-start justify-content-center d-flex'>
                                <ul className='list'>
                                    <li>Architectural Acoustic Solutions</li>
                                    <li>Auditorium Acoustic Treatment</li>
                                    <li>Cinema & Home Theatre Acoustics</li>
                                    <li>Recording Studio Soundproofing</li>
                                    <li>Office Noise Control Systems</li>
                                    <li>Industrial Acoustic Enclosures</li>
                                    <li>Custom Acoustic Panel Manufacturing</li>
                                </ul>
                            </div>
                        </div>
                        <h1 className='com-header3'>Our Core Services</h1>
                        <div className='row align-items-center'>
                            <div className='col-sm-12 col-md-6 order-2 order-md-1 justify-content-center d-flex align-items-center'>
                                <ul className='list'>
                                    <li>Architectural Acoustic Solutions</li>
                                    <li>Auditorium Acoustic Treatment</li>
                                    <li>Cinema & Home Theatre Acoustics</li>
                                    <li>Recording Studio Soundproofing</li>
                                    <li>Office Noise Control Systems</li>
                                    <li>Industrial Acoustic Enclosures</li>
                                    <li>Custom Acoustic Panel Manufacturing</li>
                                </ul>
                            </div>
                            <div className='col-sm-12 col-md-6 order-1 order-md-2 align-items-start justify-content-center d-flex'>
                                <img src={company6} alt="Acoustic sound barrier installation" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id='company'>
                <div className='contact'>
                    <div className='container p-4'>
                        <h1 className='com-header4'>Our Commitment to Quality</h1>
                        <p className='white-para'>At Sound Barrier Manufacture, quality and performance are our top

                            priorities. Our acoustic products are engineered using premium-grade

                            materials that meet industry acoustic performance standards. Every

                            project undergoes careful planning, acoustic assessment, and precision

                            installation to ensure maximum noise reduction efficiency.</p>

                        <h1 className='com-header5'>Quotes & Contact</h1>
                        <div className='row p-2 mt-3'>
                            <div className="col-12 col-md-6 mt-3">
                                <p className='white-para'>Need privacy from noisy neighbours?</p>
                                <p className='white-para'>Contact us today!</p>
                                <div className="row">
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            className="form-control"
                                            placeholder="Name *"
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="email"
                                            name="mail"
                                            id="mail"
                                            className="form-control"
                                            placeholder="Email *"
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            className="form-control"
                                            placeholder="Phone *"
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <textarea
                                            rows={4}
                                            id="message"
                                            className="form-control"
                                            placeholder="Message *"
                                        ></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button
                                            className="btn"
                                            type="button"
                                            onClick={handleClick}
                                        >
                                            SEND
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12 col-md-6 align-items-center justify-content-center d-flex mt-3'>
                                <p className='white-para'>Acoustical Surfaces Industries LLP. <br />
                                    130/2B, Morappampalayam,<br />
                                    Uppilipalayam (P.O), Karuvalur<br />
                                    Tirupur - 641670<br />
                                    Tamil Nadu, India<br />
                                    <b>Tel:</b>{" "}
                                    <a href="tel:+919449777212">+91-9449777212</a> |{" "}
                                    <a href="tel:+918277331000">+91-82773 31000</a><br />
                                    <a
                                        href="mailto:mail@acousticalsurfaces.in?subject=Inquiry&body=Hello, I would like to know more about your services."
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        mail@acousticalsurfaces.in
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Company